module.exports = __webpack_public_path__ + "img/f052783.jpg";